import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2
} from '@angular/core';
import {
  NavigationEnd,
  NavigationError,
  RouteConfigLoadStart,
  Router
} from '@angular/router';
import {
  TitleService,
  VERSION as VERSION_ALAIN,
  stepPreloader
} from '@delon/theme';
import { environment } from '@env/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { VERSION as VERSION_ZORRO } from 'ng-zorro-antd/version';

import { DropdownService } from './core/util/dropdown.service';
import { AppService } from './shared/services/app.service';

declare global {
  interface Window {
    app: any;
  }
}

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.less'],
  template: ` <router-outlet></router-outlet> `,
  standalone: false
})
export class AppComponent implements OnInit {
  private donePreloader = stepPreloader();
  constructor(
    el: ElementRef,
    renderer: Renderer2,
    private router: Router,
    private titleSrv: TitleService,
    private modalSrv: NzModalService,
    private msg: NzMessageService,
    private appSrv: AppService,
    private dropdownService: DropdownService
  ) {
    renderer.setAttribute(
      el.nativeElement,
      'ng-alain-version',
      VERSION_ALAIN.full
    );
    renderer.setAttribute(
      el.nativeElement,
      'ng-zorro-version',
      VERSION_ZORRO.full
    );

    // refer to WI 13702, disable drag and drop form value to other fields
    if (document?.body?.addEventListener)
      document.body.addEventListener('drop', event => event.preventDefault());
  }

  ngOnInit(): void {
    let configLoad = false;
    this.router.events.subscribe(ev => {
      if (ev instanceof RouteConfigLoadStart) {
        configLoad = true;
      }
      if (configLoad && ev instanceof NavigationError) {
        this.msg.info(
          environment.production
            ? `An updated version of the app may have been released. Reloading the app now.`
            : `Falied to load Route：${ev.url}`
        );
        //this.modalSrv.error({ nzTitle: 'App Error', nzContent: ev.error.stack });
        window.location.reload();
      }
      if (ev instanceof NavigationEnd) {
        this.donePreloader();
        this.titleSrv.setTitle();
        this.modalSrv.closeAll();
      }
    });

    this.appSrv.startVersionCheck();
  }

  @HostListener('window:beforeunload')
  canDeactivate() {
    if (window.app && window.app.forcereload) {
      return true;
    }

    const url = window.location.href;

    if (url.indexOf('passport/') > 0 || url.indexOf('reporting/viewer') > 0)
      return true;

    return false;
    // return confirm(
    //   'You are closing QNE AI Cloud Accounting! Please make sure all of your changes has been saved properly before you leave.'
    // );
  }
}
